export const StorageVars = {
  BDS_BILLING: 'bds-billing',
  BDS_USER_ID: 'bds-user-id',
  BDS_SIDEBAR_COLLAPSED: 'bds-sidebar-collapsed',
  REACT_QUERY_CACHE: 'REACT_QUERY_OFFLINE_CACHE',
  LOCAL_SUPABASE_AUTH_TOKEN: 'sb-localhost-auth-token',
};
